var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398ZM8.00016 2.66733C5.05464 2.66733 2.66683 5.05514 2.66683 8.00066C2.66683 10.9462 5.05464 13.334 8.00016 13.334C10.9457 13.334 13.3335 10.9462 13.3335 8.00066C13.3335 5.05514 10.9457 2.66733 8.00016 2.66733Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4716 5.52923C10.7319 5.78958 10.7319 6.21169 10.4716 6.47204L8.94295 8.00068L10.4715 9.52924C10.7318 9.78959 10.7318 10.2117 10.4715 10.472C10.2111 10.7324 9.78902 10.7324 9.52867 10.472L8.00014 8.9435L6.47165 10.472C6.21131 10.7324 5.7892 10.7324 5.52885 10.472C5.26849 10.2117 5.26849 9.78955 5.52884 9.5292L7.05734 8.00068L5.52876 6.47208C5.26841 6.21173 5.26841 5.78962 5.52876 5.52927C5.78911 5.26892 6.21122 5.26893 6.47157 5.52928L8.00014 7.05787L9.52875 5.52924C9.7891 5.26889 10.2112 5.26888 10.4716 5.52923Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/icon-error.8399f9ef91759f2821879c4a36dca5ae.svg";
export { ForwardRef as ReactComponent };